<ion-item (click)="onEntrySelect(0)">
  {{ 'UNFOLLOW_FRIEND' | translate }}
</ion-item>
<ion-item (click)="onEntrySelect(1)">
  {{ 'THE_ROUTE_PHOTOS' | translate }}
</ion-item>